module.exports = __webpack_public_path__ + "static/img/1.c59ab092.png";